import { motion } from 'motion/react'

const variants = {
  play: {
    d: 'M11,10 L18,13.74 L18,22.28 L11,26 M18,13.74 L26,18 L26,18 L18,22.28',
  },
  pause: {
    d: 'M11,10 L17,10 L17,26 L11,26 M20,10 L26,10 L26,26 L20,26',
  },
}

export const PlayPauseIcon = ({ isPlaying = false }) => {
  return (
    <div>
      <svg width="14" height="16" viewBox="0 0 16 16" className="h-10 w-10">
        <g style={{ transform: 'translate(-10px, -10px)' }}>
          <motion.path
            fill="#303030"
            variants={variants}
            initial="play"
            animate={isPlaying ? 'pause' : 'play'}
            transition={{
              duration: 0.3,
              ease: [0.7, 0, 0.1, 0.95],
            }}
          />
        </g>
      </svg>
    </div>
  )
}
